export default "__VITE_ASSET__0404dfe1__"